import PostExcelForOrganisationRequestModelBase from '../_generated/modelBases/post-excel-for-organisation-request-model-base';

export default class PostExcelForOrganisationRequestModel extends PostExcelForOrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
